import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { getSearchSettings } from 'libs/core/data/stores/search-settings';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SliderModule } from 'primeng/slider';
import { TooltipModule } from 'primeng/tooltip';
import { debounceTime, take } from 'rxjs';

import { SearchSettingsResponse } from '@offconon/core-api';
import { CommonCountry } from '@offconon/core-api';
import { AllCountryMultiSelectListComponent } from '@offconon/shared/ui/form-elements/country-select-list';
import { MiscService } from '@offconon/shared/utils/services/misc';

@Component({
  selector: 'offconon-country-and-city-search',
  templateUrl: './country-and-city-search.component.html',
  styles: [],
  imports: [
    RadioButtonModule,
    FormsModule,
    MatIcon,
    TooltipModule,
    AllCountryMultiSelectListComponent,
    InputTextModule,
    ReactiveFormsModule,
    RouterLinkActive,
    RouterLink,
    SliderModule,
    TranslateModule,
  ],
})
export class CountryAndCitySearchComponent implements OnInit {
  @Input() showInfo = false;
  @Input() countryFormControl: FormControl;
  @Input() cityFormControl: FormControl;
  @Input() distanceFormControl: FormControl;
  @Input() preSelectShippingCountry = true;
  miscService = inject(MiscService);
  private store$ = inject(Store);

  countries?: CommonCountry[];

  city: string;
  distanceSwitch = false;

  filterType = 0;
  selected_country_id: any = undefined;

  searchSettings: Partial<SearchSettingsResponse> | undefined;
  showSearchSettingSetup = false;

  selectedCountries: any = [];
  selectedCity: number;
  ngOnInit(): void {
    this.store$
      .select(getSearchSettings)
      .pipe(debounceTime(300), take(1))
      .subscribe({
        next: (res) => {
          this.searchSettings = res;

          this.showSearchSettingSetup = this.searchSettings?.lat ? false : true;

          if (this.searchSettings && this.preSelectShippingCountry) {
            this.filterType = 1;
            this.selectedCountries = [this.searchSettings?.ship_to_country?.id];
            if (this.selectedCountries.length > 0) {
              this.countryFormControl.patchValue(this.selectedCountries);
            }
          }
        },
      });
  }

  resetAllData() {
    this.resetCity();
    this.resetCountry();
    this.resetDistance();
  }

  resetCity() {
    this.cityFormControl.setValue('');
  }

  resetCountry() {
    this.countryFormControl.setValue([]);
  }

  resetDistance() {
    this.distanceFormControl.setValue(0);
  }

  setDistance() {
    if (!this.showSearchSettingSetup) this.distanceFormControl.patchValue(500);
  }
}
